import type { ApplicationRepositoryInterface } from '@/api/interfaces/application/applicationRepository';
import { staticImplements } from '@/decorators/staticImplements';
import { httpClient } from '../httpClient/httpClient';
import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import { convertFormConfigToFormDto } from '@/services/form/dto';
import { FormDto } from '@/services/form/dto';
import { ServiceSuccess } from '@/api/interfaces/serviceSuccess';
import { ApplicationUpdateDataModel } from '@/types/app/application/applicationUpdateDataModel';
import { GetApplicationsResponse } from '@/api/interfaces/application/getApplicationsResponse';

@staticImplements<ApplicationRepositoryInterface>()
export class ApplicationRepository {
    static fetchApplications({
        offset,
        query,
        limit,
        dateSentAtStart,
        dateSentAtEnd,
        sortByColumn,
        sortDirection,
        statuses,
    }: ApplicationUpdateDataModel): Promise<GetApplicationsResponse> {
        return httpClient.get<GetApplicationsResponse>(
            '/api/dea/v1/application',
            {
                params: {
                    query,
                    offset,
                    limit,
                    dateSentAtStart,
                    dateSentAtEnd,
                    sortByColumn,
                    sortDirection,
                    statuses,
                },
            },
        );
    }

    static getApplicationData(applicationId: string): Promise<FormDto> {
        return httpClient.get<FormDto>(
            `/api/dea/v1/application/${applicationId}/data`,
        );
    }

    static copyApplication(applicationId: string): Promise<string> {
        return httpClient.get<string>(
            `/api/dea/v1/application/${applicationId}/copy`,
        );
    }

    static deleteApplication(applicationId: string): Promise<ServiceSuccess> {
        return httpClient.delete<ServiceSuccess>(
            `/api/dea/v1/application/${applicationId}`,
        );
    }

    static saveApplication(model: ApplicationForm): Promise<string> {
        return httpClient.post<string>(
            `/api/dea/v1/application/${model.applicationId}`,
            {
                data: { ...convertFormConfigToFormDto(model) },
            },
        );
    }

    static sendApplication(model: ApplicationForm): Promise<ServiceSuccess> {
        return httpClient.post<ServiceSuccess>(
            `/api/dea/v1/application/${model.applicationId}/send`,
            {
                data: { ...convertFormConfigToFormDto(model) },
            },
        );
    }
}
